import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { UserRole } from "@balizahub/shared";
import { AuthService } from "../services/auth.service";

/** Allows access only to users with role === 'instructor'.
 *  Unauthenticated users → /entrar, non-instructors → /app  */
export const instructorGuard: CanActivateFn = (_route, _state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const user = auth.currentUser();

  if (!user) {
    return router.createUrlTree(["/entrar"]);
  }

  if (!user.roles.includes(UserRole.INSTRUCTOR)) {
    return router.createUrlTree(["/app"]);
  }

  return true;
};
